import { useSession } from '../../contexts/session';

import { Initials } from '../initials';

import styles from './style.module.css';

// Who is signed in, at the top of the phone menu's footer: initials, name
// and email, above Profile & settings.
export function MenuProfile() {
  const { me } = useSession();
  const { firstName, lastName } = me.profile;

  return (
    <div className={ styles.profile }>
      <Initials firstName={ firstName } lastName={ lastName }/>

      <span className={ styles.lines }>
        <span className={ styles.name }>{ `${ firstName } ${ lastName }` }</span>
        <span className={ styles.email }>{ me.email }</span>
      </span>
    </div>
  );
}
